import styled from 'styled-components';
import { colors } from '@keen.io/colors';
export var Container = styled.div.withConfig({
  displayName: "SettingsContainerstyles__Container",
  componentId: "keen-widget-settings__sc-1fhj2uq-0"
})(["&&&{position:relative;}"]);
export var Mask = styled.div.withConfig({
  displayName: "SettingsContainerstyles__Mask",
  componentId: "keen-widget-settings__sc-1fhj2uq-1"
})(["&&&{position:absolute;top:0;left:0;width:100%;height:100%;background:", ";opacity:0.5;cursor:not-allowed;}"], colors.white[500]);